import { render } from "./data-selector.vue?vue&type=template&id=1ca895d7&ts=true"
import script from "./data-selector.ts?vue&type=script&lang=ts"
export * from "./data-selector.ts?vue&type=script&lang=ts"

import "./data-selector.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__